import React from "react";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { TICKET_POST_FORM_SEND_PERMISSION } from "components/dashboard/AgentInbox/permissions";
import "./TicketsPFCollection.scss";

const TicketsPFCollection = ({
    branchCollectionName,
    sendCollectionToTicket,
}) => {
    return (
        <ComponentAccessControl
            baseResources={TICKET_POST_FORM_SEND_PERMISSION}>
            <div
                className={"pf__branches--branch"}
                onClick={sendCollectionToTicket}>
                <span>{branchCollectionName}</span>
            </div>
        </ComponentAccessControl>
    );
};

export default TicketsPFCollection;
